import React, { useState } from "react";
import "./AirlineIdentity.css";

export default function AirlineIdentity({
  airline,
  secondaryAirline = null,
  size = "md",
  logoSrc = null,
}) {
  const [failedSrc, setFailedSrc] = useState("");
  if (!airline) return null;
  const code = String(airline.code || airline.logoText || "").toUpperCase();
  const resolvedLogo = String(logoSrc || airline.logoUrl || airline.logo || "").trim();
  const showLogo = Boolean(resolvedLogo) && failedSrc !== resolvedLogo;
  return (
    <div className={`fe2-airline fe2-airline--${size}`}>
      {showLogo ? (
        <span
          className="fe2-airline__logo fe2-airline__logo--image"
          data-code={code}
          aria-hidden
        >
          <img
            src={resolvedLogo}
            alt=""
            className="fe2-airline__logo-img"
            decoding="async"
            onError={() => setFailedSrc(resolvedLogo)}
          />
        </span>
      ) : (
        <span
          className={`fe2-airline__logo fe2-airline__logo--${code || "XX"}`}
          data-code={code}
          aria-hidden
        >
          <span className="fe2-airline__logo-mark" />
          <span className="fe2-airline__logo-code">{airline.logoText || airline.code}</span>
        </span>
      )}
      <div className="fe2-airline__text">
        <strong className="fe2-airline__name">{airline.name}</strong>
        {airline.nameHe ? (
          <span className="fe2-airline__name-he">{airline.nameHe}</span>
        ) : null}
        {secondaryAirline ? (
          <span className="fe2-airline__secondary">+ {secondaryAirline.name}</span>
        ) : null}
      </div>
    </div>
  );
}
